import variables from '../styles/variables.scss';
import { atom, getDefaultStore, useAtomValue } from 'jotai';
import { Viewport } from '../types';

const tabletMediaMatcher = window.matchMedia(`(min-width: ${variables.tabletMinViewport})`);
const desktopMediaMatcher = window.matchMedia(`(min-width: ${variables.desktopMinViewport})`);

const getInitialViewport = (): Viewport => {
  if (desktopMediaMatcher.matches) {
    return 'desktop';
  } else if (tabletMediaMatcher.matches) {
    return 'tablet';
  } else {
    return 'mobile';
  }
};

const viewport = atom<Viewport>(getInitialViewport());

const updateViewport = () => {
  const store = getDefaultStore();
  if (desktopMediaMatcher.matches) {
    store.set(viewport, 'desktop');
  } else if (tabletMediaMatcher.matches) {
    store.set(viewport, 'tablet');
  } else {
    store.set(viewport, 'mobile');
  }
};

tabletMediaMatcher.addEventListener('change', updateViewport);
desktopMediaMatcher.addEventListener('change', updateViewport);

export const useViewport = () => {
  const value = useAtomValue(viewport);

  return {
    viewport: value ?? 'tablet',
    isMobile: value === 'mobile',
    isTablet: value === 'tablet',
    isDesktop: value === 'desktop',
    isSmallScreen: window.innerHeight < parseInt(variables.smallScreenHeight, 10),
  };
};
